import React, { useLayoutEffect, useRef, useState } from 'react';

// A single-line label that fades out at the right edge — but only when the
// text actually overflows. A fixed mask faded the last letters of words that
// fit ("Crossfit" → "Crossfi…"), which read as a bug. Overflow can't be known
// in CSS, so this measures: scrollWidth > clientWidth toggles the mask.
// Re-measured on resize (rotation, split view) via ResizeObserver.
const FadeClip = ({ children, className = '', ...rest }) => {
  const ref = useRef(null);
  const [overflows, setOverflows] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      // +1 tolerates sub-pixel rounding so a label that fits exactly stays crisp.
      const next = el.scrollWidth > el.clientWidth + 1;
      setOverflows((prev) => (prev === next ? prev : next));
    };
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [children]);

  return (
    <span
      ref={ref}
      className={`fade-clip ${overflows ? 'fade-clip--overflow' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </span>
  );
};

export default FadeClip;
